import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 16,
		height: 16,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function TagIcon(props) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M8.60664 2.12132C8.07621 2.12132 7.5675 2.33203 7.19243 2.70711L1.41425 8.48528C0.633206 9.26633 0.633206 10.5327 1.41425 11.3137L4.94979 14.8492C5.73084 15.6303 6.99717 15.6303 7.77822 14.8492L13.5564 9.07107C13.9315 8.69599 14.1422 8.18729 14.1422 7.65685L14.1422 5.07107C14.1422 4.54063 13.9315 4.03193 13.5564 3.65685L12.6066 2.70711C12.2316 2.33203 11.7229 2.12132 11.1924 2.12132L8.60664 2.12132ZM8.83888 7.42462C9.42466 8.01041 10.3744 8.01041 10.9602 7.42462C11.546 6.83883 11.546 5.88909 10.9602 5.3033C10.3744 4.71751 9.42466 4.71751 8.83888 5.3033C8.25309 5.88909 8.25309 6.83883 8.83888 7.42462Z" fill={props.fill} />
		</svg>

	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<TagIcon fill={props.fill} />
		</div>
	);
}